export const comments_5618660 = {"data":{"data":[],"links":{}}}